import { TFunction } from 'i18next';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
// eslint-disable-next-line no-restricted-imports
import moment from 'moment';
import { AttendanceTotalsReportType, StudentAttendanceTotalsType } from '../types';

import { formatHoursFromMinutes } from '../../../helpers/dates';

import { initializeAttendancePDFDoc } from './pdfUtils';

const COLUMNS = [
  { headerKey: 'attendance.list.pdf.studentNameColumn', dataKey: 'studentName' },
  { headerKey: 'attendance.totalsTable.roomColumn', dataKey: 'roomName' },
  { headerKey: 'attendance.totalsTable.daysPresentColumn', dataKey: 'daysPresent' },
  { headerKey: 'attendance.totalsTable.daysAbsentColumn', dataKey: 'daysAbsent' },
  { headerKey: 'attendance.totalsTable.totalHoursColumn', dataKey: 'totalHoursAttended' },
];

export async function generateAttendanceTotalsPDF(
  report: AttendanceTotalsReportType,
  t: TFunction
): Promise<{ filename: string; pdf: jsPDF }> {
  const { location, items: attendanceTotals, organization } = report;

  const startDate = moment(report.startDate).format('DD_MM_YYYY');
  const endDate = moment(report.endDate).format('DD_MM_YYYY');

  const filename = t('attendance.export.totalsPdfFileName', { startDate, endDate });
  const title = t('attendance.export.reportTitle', {
    locationName: location?.name || organization?.name || t('attendance.export.unknownLocation'),
  });
  const pdf = initializeAttendancePDFDoc(title, report);
  const body = createPDFBody(attendanceTotals);

  autoTable(pdf, {
    columns: COLUMNS.map(({ headerKey, ...column }) => ({ ...column, header: t(headerKey) })),
    body: body,
    startY: 65,
  });
  return { filename, pdf };
}

function createPDFBody(attendanceTotals: StudentAttendanceTotalsType[]) {
  return attendanceTotals.map((data) => {
    return {
      studentName: data.studentName || '-',
      roomName: data.roomName || '-',
      daysPresent: data.daysPresent,
      daysAbsent: data.daysAbsent,
      totalHoursAttended:
        !isNaN(data.totalMinutesAttended) && data.totalMinutesAttended !== 0
          ? formatHoursFromMinutes(data.totalMinutesAttended)
          : '-',
    };
  });
}
